var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractPolicy, AbstractPolicyManager } from './IPolicy';
/**
 * p, object
 */
var DefaultPolicy = /** @class */ (function (_super) {
    __extends(DefaultPolicy, _super);
    function DefaultPolicy(config, expr) {
        var _this = _super.call(this, expr) || this;
        var configs = config.split(',').map(function (c) { return c.trim(); });
        _this.expr = expr.replace(/^p, ?/, '');
        var es = _this.expr.split(',').map(function (e) { return e.trim(); });
        configs.forEach(function (c, index) {
            _this[c] = es[index];
        });
        return _this;
    }
    return DefaultPolicy;
}(AbstractPolicy));
export { DefaultPolicy };
/**
 * p = obj
 */
var DefaultPolicyManager = /** @class */ (function (_super) {
    __extends(DefaultPolicyManager, _super);
    function DefaultPolicyManager(expr) {
        var _this = _super.call(this, expr.replace(/^p ?= ?/, '')) || this;
        _this._policies = [];
        return _this;
        // this.policies = expr.map(e => new DefaultPolicy(e));
    }
    Object.defineProperty(DefaultPolicyManager.prototype, "policies", {
        get: function () {
            return this._policies;
        },
        enumerable: true,
        configurable: true
    });
    DefaultPolicyManager.prototype.addPolicies = function (expr) {
        var _this = this;
        this._policies = expr.map(function (e) { return new DefaultPolicy(_this.expr, e); });
    };
    return DefaultPolicyManager;
}(AbstractPolicyManager));
export { DefaultPolicyManager };
